import { desktopFirstQuery } from '@inflearn/ds-react-next';
import { useMediaQuery as useMediaQueryHook } from '@mantine/hooks';

export default function useMediaQuery() {
  const isMobile = useMediaQueryHook(desktopFirstQuery.mobile);

  return {
    isMobile,
  };
}
